import { render, staticRenderFns } from "./JobAudienceForm.vue?vue&type=template&id=727c5cf7&"
import script from "./JobAudienceForm.vue?vue&type=script&lang=js&"
export * from "./JobAudienceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports